import { cx, styled } from "simplydo/react/styled";

import { Icon } from "../icon";
import type { CardHeaderProps } from "./Card.types";

const HeaderEl = styled.div`
  padding: 1em;
  margin: 0;
  border-bottom: 1px solid rgba(34, 36, 38, 0.08);

  ${Icon}:first-child {
    margin-right: 0.5rem;
  }
`;

const CardHeaderComponent = (props: CardHeaderProps) => {
  const { children, className, style } = props;
  return (
    <HeaderEl className={cx(className)} style={style}>
      {children}
    </HeaderEl>
  );
};

export const CardHeader = styled(CardHeaderComponent)``;
